module.exports = __webpack_public_path__ + "static/media/sad_robot_1x.49a7ae21.png";